import { defineComponent as _defineComponent } from 'vue'
import { NameType } from '@/views/Automation/CampaignCreatorV2/ab/core/helpers';
import CcAlert from '@/views/Automation/CampaignCreatorV2/components/CcAlert/CcAlert.ts.vue';
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcCreateTemplateModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcCreateTemplateModal.ts.vue';
import useAdStore from '@/views/Automation/CampaignCreatorV2/store/Ad';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { useTour } from '../../helpers/tourGuide';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdName.ts',
  setup(__props) {

const adStore = useAdStore();
const { getField, getMacroOptions } = storeToRefs(adStore);

onMounted(() => {
  useTour('Ads');
});

const adName = computed(() => {
  const name = getField.value('name')?.value;
  return name[0];
});

const currentName = computed(() => adName.value?.value || {});

const macros = computed(() => getMacroOptions.value);

const createTemplateModal = ref<NullableType<InstanceType<typeof CcCreateTemplateModal>>>(null);

function onNameChange(value: string, variableId = 'name') {
  adStore.addOrEditVariable('name', { field: 'name', value: { ...currentName.value, name: value }, variableId });
}

function openCreateTemplateModal() {
  createTemplateModal.value?.onModalOpen();
}

function onTemplateCreate(value: Omit<NameType, 'name'>, variableId = 'name') {
  adStore.addOrEditVariable('name', {
    field: 'name',
    value: { ...currentName.value, ...value },
    variableId,
  });
}

return { __sfc: true,adStore, getField, getMacroOptions, adName, currentName, macros, createTemplateModal, onNameChange, openCreateTemplateModal, onTemplateCreate, CcAlert, CcCard, CcError, CcIcon, CcCreateTemplateModal }
}

})